<script setup lang="ts">
import { useLayout } from '@/layout/composables/layout.js';
import { computed, ref, watch } from 'vue';
import AppFooter from './footer/AppFooter.vue';
import AppSidebar from './sidebarMenu/AppSidebar.vue';
import AppTopbar from './header/AppTopbar.vue';
import AppMenuPaletaBusca from './sidebarMenu/AppMenuPaletaBusca.vue';

import {useLayoutConfigurator} from "@/layout/header/layoutConfigurator";

const { layoutConfig, layoutState, isSidebarActive, resetMenu } = useLayout();

const outsideClickListener = ref<any>(null);

const {setUserTheme} = useLayoutConfigurator();



watch(isSidebarActive, (newVal) => {
    if (newVal) {
        bindOutsideClickListener();
    } else {
        unbindOutsideClickListener();
    }
});

const containerClass = computed(() => {
    return {
        'layout-overlay': layoutConfig.menuMode === 'overlay',
        'layout-overlay-active': layoutState.overlayMenuActive,
        'layout-mobile-active': layoutState.staticMenuMobileActive
    };
});
const bindOutsideClickListener = () => {
    if (!outsideClickListener.value) {
        outsideClickListener.value = (event : any) => {
            if (isOutsideClicked(event)) {
                resetMenu();
            }
        };
        document.addEventListener('click', outsideClickListener.value);
    }
};
const unbindOutsideClickListener = () => {
    if (outsideClickListener.value) {
        document.removeEventListener('click', outsideClickListener as any);
        outsideClickListener.value = null;
    }
};
const isOutsideClicked = (event: any) => {
    const sidebarEl = document.querySelector('.layout-sidebar');
    const topbarEl = document.querySelector('.layout-menu-button');

    return !(sidebarEl?.isSameNode(event.target) || sidebarEl?.contains(event.target) || topbarEl?.isSameNode(event.target) || topbarEl?.contains(event.target));
};


//Aplica o tema do usuario

  setUserTheme();


</script>

<template>
    <div class="layout-wrapper" :class="containerClass">
      <AppTopbar/>

        <app-sidebar></app-sidebar>
        <div class="layout-main-container">
            <div class="layout-main">
                <router-view></router-view>
            </div>
            <AppFooter/>
        </div>
        <div class="layout-mask animate-fadein"></div>
    </div>
    <Toast />
    <AppMenuPaletaBusca />
</template>
